import DOMPurify from 'dompurify'
import { renderGoogleFormLink } from './googleForms.js'

export function normalizeThankYouPageMessage(message) {
  if (!message?.trim()) return null

  const container = document.createElement('div')
  let html = message

  // Preserve line breaks in messages saved by the original plain-text editor.
  if (!/<\/?[a-z][^>]*>/i.test(message)) {
    container.textContent = message
    html = container.innerHTML.replace(/\r\n|\r|\n/g, '<br>')
  }

  const sanitized = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'blockquote', 'pre', 'code', 'ol', 'ul', 'li', 'a'],
    ALLOWED_ATTR: ['href', 'title'],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false
  })
  container.innerHTML = sanitized

  // Quill represents an empty editor with markup such as <p><br></p>.
  return container.textContent.replace(/[\s\u200B\uFEFF]+/g, '') ? sanitized : null
}

export function renderThankYouPageMessage(message, donation) {
  const normalized = normalizeThankYouPageMessage(message)
  if (!normalized) return null

  const [firstName, ...lastName] = (donation?.billing_name || '').trim().split(/\s+/)
  const values = {
    'donor.first_name': firstName,
    'donor.last_name': lastName.join(' '),
    'donor.email': donation?.billing_email || ''
  }
  const container = document.createElement('div')
  container.innerHTML = normalized

  // Insert donor text without interpreting it as HTML.
  const walker = document.createTreeWalker(container, window.NodeFilter.SHOW_TEXT)
  while (walker.nextNode()) {
    const node = walker.currentNode
    node.nodeValue = node.nodeValue.replace(/\{\{\s*([a-zA-Z0-9_.]+)\s*\}\}/g, (token, key) => {
      return Object.hasOwn(values, key) ? values[key] : token
    })
  }

  // Only supported Google Form answer parameters may receive donor values.
  for (const link of container.querySelectorAll('a[href]')) {
    link.setAttribute('href', renderGoogleFormLink(link.getAttribute('href'), values))
  }

  return container.textContent.replace(/[\s\u200B\uFEFF]+/g, '') ? container.innerHTML : null
}
